import { useEffect, useState } from "react";
import { useLayout } from "@/contexts/LayoutContext";
import { searchAutocomplete, getRedirectUrl } from "@/api/autocomplete/api";
import { showErrorToast } from "@/hooks/use-toast";
import { SearchResultItem } from "@/types/domain";

const MAX_RECENTS = 10;

export const RecentCompanies = () => {
  const { data } = useLayout();
  const [items, setItems] = useState<SearchResultItem[]>([]);

  useEffect(() => {
    const companyType =
      data.searchTypes.find((s) => s.id === "Company" || s.parentOptionGroup === "Company") ??
      data.searchTypes.find((s) => s.id === data.selectedSearchType);
    if (!companyType) return;

    let cancelled = false;
    searchAutocomplete("", companyType.id, companyType.description)
      .then((results) => { if (!cancelled) setItems(results.slice(0, MAX_RECENTS)); })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, [data.searchTypes, data.selectedSearchType]);

  if (items.length === 0) return null;

  const open = (item: SearchResultItem) => {
    if (!item.target) return;
    getRedirectUrl(item.id, item.target, "")
      .then((redirect) => { if (redirect) window.location.assign(data.appRoutes.root + redirect); })
      .catch(() => { showErrorToast("Failed to navigate to result."); });
  };

  return (
    <section aria-label="Recent companies" className="mt-2 border-t border-white/20 px-2.5 pt-3 pb-4" data-testid="side-nav-recent-companies">
      <h3 className="px-2 pb-1 text-xs font-medium uppercase tracking-wide text-white/50">Recent companies</h3>
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => open(item)}
              className="block w-full rounded-md px-3 py-1.5 text-left text-sm text-white/90 hover:bg-white/10 focus-visible:bg-white/10 focus:outline-none"
            >
              {item.label.replace(/\s*\([^)]*\)\s*$/, "")}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
